import { css } from "@emotion/react";
import { Theme, useTheme } from "@mui/material";
import Link from "next/link";

import { fixedWidth, flexColumn, flexRow } from "~/lib/client/design";
import useIsSpMode, { SP_MODE_WIDTH } from "~/lib/client/hooks/useIsSpMode";

type Props = { id: number; title: string; category: string };

const PcFormListItem = ({ id, title, category }: Props) => {
  const theme = useTheme();
  return (
    <Link key={id} css={rootStyle} href={`/database/${id}`}>
      <p css={formIdStyle}>#{id}</p>
      <p css={categoryNameStyle(theme)}>{category}</p>
      <p css={formTitleStyle}>{title}</p>
    </Link>
  );
};

const rootStyle = css`
  ${flexRow};
  align-items: flex-start;

  @media (max-width: ${SP_MODE_WIDTH}px) {
    align-items: center;
  }
`;

const formIdStyle = css`
  ${fixedWidth("3rem")};
  font-size: 14px;

  @media (max-width: ${SP_MODE_WIDTH}px) {
    font-size: 12px;
    margin: 0;
  }
`;

const categoryNameStyle = (theme: Theme) => css`
  color: ${theme.palette.primary.main};
  font-size: 12px;
  ${fixedWidth("8rem")};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: ${SP_MODE_WIDTH}px) {
    font-size: 10px;
    margin: 0;
    ${fixedWidth("6rem")};
  }
`;

const formTitleStyle = css`
  font-size: 12px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (min-width: ${SP_MODE_WIDTH}px) {
    ${fixedWidth("27rem")};
  }

  @media (max-width: ${SP_MODE_WIDTH}px) {
    margin: 0.5rem 0 0.5rem 0;
  }
`;

const SpFormListItem = ({ id, title, category }: Props) => {
  const theme = useTheme();
  return (
    <Link key={id} css={rootStyle} href={`/database/${id}`}>
      <div css={flexColumn}>
        <p css={formIdStyle}>#{id}</p>
        <p css={categoryNameStyle(theme)}>{category}</p>
      </div>
      <p css={formTitleStyle}>{title}</p>
    </Link>
  );
};

const FormListItem = (props: Props) => {
  const isSpMode = useIsSpMode();

  return isSpMode ? (
    <SpFormListItem {...props} />
  ) : (
    <PcFormListItem {...props} />
  );
};

export default FormListItem;
